/** Versão do contrato que este build entende. Ver §5 do spec de desenho. */
export const SCHEMA_VERSION = 1;

export interface IRemoteConfigPayload {
  schemaVersion: number;
  app: string;
  env: string;
  config: {
    /** Chave = membro de EntityPath. O valor pode trazer prefixo de path. */
    hosts: Record<string, string>;
    /** Endereços nossos. Validados por sufixo de domínio. */
    urls: Record<string, string>;
    /** Terceiros. Validados por host EXATO — ver remote-config.allowlist.ts. */
    externalUrls: Record<string, string>;
    braspag: { providerMerchantId: string; providerOrgId: string };
    successCodesCheckout: string[];
  };
  flags: Record<string, unknown>;
  gates: Record<string, unknown>;
}
